/* ML – Product page redesign (Option A) */
(function () {
  document.querySelectorAll('[data-ml-pdp]').forEach(function (root) {
    var id = root.getAttribute('data-ml-pdp');
    var dataEl = document.querySelector('script[data-ml-variants="' + id + '"]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var form = root.querySelector('[data-ml-form]');
    var input = root.querySelector('[data-ml-variant-input]');
    var priceEl = root.querySelector('[data-ml-price]');
    var atc = root.querySelector('[data-ml-atc]');
    var atcText = root.querySelector('[data-ml-atc-text]');
    var msg = root.querySelector('[data-ml-msg]');
    var mto = root.querySelector('[data-ml-mto]');
    var fs = root.querySelector('[data-ml-fs]');
    var track = root.querySelector('[data-ml-track]');
    var slides = root.querySelectorAll('[data-ml-slide]');
    var thumbs = root.querySelectorAll('[data-ml-thumb]');
    var dots = root.querySelectorAll('.ml-dots i');
    var countEl = root.querySelector('[data-ml-count]');
    var sticky = root.querySelector('[data-ml-sticky]');

    /* ---------- gallery ---------- */
    function goTo(i, smooth) {
      var s = slides[i]; if (!s || !track) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (countEl) countEl.textContent = i + 1;
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-ml-thumb'); goTo(i); setActive(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var best = 0, bd = Infinity;
          slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft); if (d < bd) { bd = d; best = k; } });
          setActive(best);
        });
      }, { passive: true });
    }

    /* ---------- variants ---------- */
    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-ml-option]:checked').forEach(function (r) { opts[+r.getAttribute('data-ml-option')] = r.value; });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); })[0];
    }
    function applyVariant(v, fromUser) {
      if (!v) return;
      input.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      atc.disabled = !v.available;
      atcText.textContent = v.available ? 'Add to cart — ' + v.price : 'Sold out';
      var inStock = v.t && v.q > 0;
      if (mto) mto.hidden = inStock;
      if (fs) fs.hidden = inStock;
      v.options.forEach(function (o, i) { var l = root.querySelector('[data-ml-opt-label="' + i + '"]'); if (l) l.textContent = o; });
      if (sticky) {
        var sv = sticky.querySelector('[data-ml-sticky-var]'), sp = sticky.querySelector('[data-ml-sticky-price]');
        if (sv && variants.length > 1) sv.textContent = v.title + ' · ';
        if (sp) sp.textContent = v.price;
      }
      if (fromUser) {
        if (v.media !== null && v.media !== undefined && v.media < slides.length) { goTo(v.media); setActive(v.media); }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
        input.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      }
    }
    root.querySelectorAll('[data-ml-option]').forEach(function (r) {
      r.addEventListener('change', function () { applyVariant(findVariant(selectedOptions()), true); });
    });

    /* ---------- quantity ---------- */
    var qty = root.querySelector('[data-ml-qty-input]');
    root.querySelectorAll('[data-ml-qty]').forEach(function (b) {
      b.addEventListener('click', function () { var n = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-ml-qty'))); qty.value = n; });
    });

    /* ---------- add to cart (AJAX, falls back to normal form post) ---------- */
    function updateCartCount() {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { document.querySelectorAll('.cart-count-number,[data-cart-count-number]').forEach(function (n) { n.textContent = c.item_count; }); document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } })); })
        .catch(function () {});
    }
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter !== atc) return;
        e.preventDefault();
        if (atc.disabled) return;
        atc.classList.add('is-loading'); atc.disabled = true;
        var fd = new FormData(form);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            msg.hidden = false;
            if (res.ok) { msg.classList.remove('is-err'); msg.innerHTML = 'Added to your cart. <a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart">View cart</a>'; updateCartCount(); }
            else { msg.classList.add('is-err'); msg.textContent = res.j.description || res.j.message || 'Sorry, something went wrong. Please try again.'; }
          })
          .catch(function () { form.submit(); })
          .finally(function () { atc.classList.remove('is-loading'); var v = variants.filter(function (x) { return String(x.id) === String(input.value); })[0]; atc.disabled = v ? !v.available : false; });
      });
    }

    /* ---------- sticky mobile bar ---------- */
    var row = root.querySelector('[data-ml-atc-row]');
    if (sticky && row && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { var past = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true'); });
      });
      io.observe(row);
      sticky.querySelector('[data-ml-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ---------- chat: open Gorgias if present, otherwise email ---------- */
    root.querySelectorAll('[data-ml-chat]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.GorgiasChat && typeof GorgiasChat.open === 'function') { e.preventDefault(); GorgiasChat.open(); }
      });
    });
  });
})();
